import { FC, SVGAttributes } from 'react';

type RotateSvgProps = SVGAttributes<SVGElement>;

export const RotateSvg: FC<RotateSvgProps> = ({ ...props }) => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M20 10C19.083 6.54955 15.8489 4 12 4C8.15106 4 4.91697 6.54955 4 10M4 14C4.91697 17.4505 8.15106 20 12 20C15.8489 20 19.083 17.4505 20 14"
                stroke={'black'}
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M4 14L4 17"
                stroke={'black'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20 7L20.0002 9.99995"
                stroke={'black'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
